import React, { useState, useEffect } from "react";
import Logout from "./Logout.js";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavbarText,
} from "reactstrap";
import BaseImage from "../baseComponents/baseImage.js";
import HotNotification from "./HotNotification.js";

import NotVerifiedView from "../views/loginStack/NotVerifiedView/NotVerifiedView.js";

import ThemeSelector from "./ThemeSelector.js";
import LanguageSelector from "./LanguageSelector.js";
import useColors from "../customHooks/useColors.js";

import routes from "../views/routes.js";

import BaseHyprelink from "../baseComponents/baseHyperlink.js";

import useBootstrap from "../customHooks/useBootstrap.js";

import { useSelector } from "react-redux";

import WithVerifyMobileModal from "../HOC/WithVerifyMobileModal.js";
import WithVerifyMailModal from "../HOC/WithVerifyMailModal.js";

import MessagesSVG from "../assets/message.svg";
import MessagesNewSVG from "../assets/message-new.svg";
import { useNavigate } from "react-router-dom";

function MyNavbar({
  autoCollapseOnClick = true,
  openVerifyMobileModal = () => {},
  openVerifyMailModal = () => {
    alert("ba");
  },
}) {
  ///////////////////////////////////////////redux state
  const loginState = useSelector((state) => state.loginState);
  const userState = useSelector((state) => state.userState);

  const isPhoneVerified = loginState.login.userInfo.isPhoneVerified;
  const isMailVerified = loginState.login.userInfo.isMailVerified;

  const { trashold } = useBootstrap();

  const [currentColors] = useColors();

  const navExpand = { expand: trashold };

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const closeNavbar = () => setIsOpen(false);

  const navigate = useNavigate();

  const userMessagesList = userState.messages;
  const [useNotSeenIcon, setUseNotSeenIcon] = useState(false);

  const handleMessagesClick = () => {
    navigate("/messagesPage");
  };

  useEffect(() => {
    const hasNotSeenMessages = userMessagesList.some(
      (message) => message.seen === "N"
    );

    if (hasNotSeenMessages) {
      setUseNotSeenIcon(true);
    } else {
      setUseNotSeenIcon(false);
    }

    return () => {};
  }, [userMessagesList]);

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        left: 0,
        zIndex: "1000",
      }}
    >
      <Navbar
        style={{
          backgroundColor: currentColors.quinary,
          paddingBottom: "1em",

          // borderBottom: `1px solid ${currentColors.quaternary}`
        }}
        {...navExpand}
      >
        <NavbarBrand style={{ width: "150px" }}>
          <BaseImage style={{ width: "100%" }} src="logo" alt="mySvgImage" />
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar style={{ alignItems: "center" }}>
          <Nav className="me-auto" navbar>
            {routes.map((route) => {
              return (
                <NavItem
                  key={route.name}
                  style={{ marginRight: "20px", marginTop: "14px" }}
                >
                  <BaseHyprelink
                    onClick={() => {
                      if (autoCollapseOnClick) {
                        closeNavbar();
                      }
                    }}
                    to={route.path}
                    style={{
                      backgroundColor: "transparent",
                      padding: "0 5px",
                      fontSize: "22px",
                    }}
                    markActive
                  >
                    {route.title}
                  </BaseHyprelink>
                </NavItem>
              );
            })}
          </Nav>
          <div
            style={{
              marginRight: "20px",
              padding: "0px 5px",
              marginTop: "14px",
              cursor: "pointer",
            }}
            onClick={handleMessagesClick}
          >
            <BaseImage
              buildSrcFromConnection={false}
              style={{ width: 20 }}
              src={useNotSeenIcon ? MessagesNewSVG : MessagesSVG}
              alt="mySvgImage"
            />
          </div>
          <ThemeSelector
            style={{
              fontSize: "22px",
              marginRight: "20px",
              padding: "0px 5px",
              paddingRight: "15px",
              marginTop: "14px",
              color: currentColors.primary,
            }}
            dropdownToogleStyle={{ padding: "0px 5px" }}
            havePadding={false}
          />
          <LanguageSelector
            style={{
              fontSize: "22px",
              marginRight: "20px",
              padding: "0px 5px",
              paddingRight: "15px",
              marginTop: "14px",
              color: currentColors.primary,
            }}
            dropdownToogleStyle={{ padding: "5px 5px" }}
            havePadding={false}
          />

          <span style={{ paddingTop: "14px", display: "flex" }}>
            <Logout
              style={{
                fontSize: "22px",
                marginRight: "20px",
                padding: "0px 5px",
              }}
            />
          </span>
        </Collapse>
      </Navbar>
      <div
        className="hotNotificationContainer"
        style={{ position: "sticky", left: 0, top: 0 }}
      >
        {(userState.mobileCountryStart ?? "") + (userState.mobile ?? "") !==
          "" &&
          isPhoneVerified === false && (
            <>
              <HotNotification
                text1="phoneNotVerified"
                text2="verifyHere"
                onClick={() => {
                  openVerifyMobileModal();
                }}
              />
            </>
          )}
        {/* mail */}
        {isMailVerified === false && (
          <>
            <HotNotification
              text1="emailNotVerified"
              text2="verifyHere"
              onClick={() => {
                openVerifyMailModal();
              }}
            />
          </>
        )}
        {/* mail */}
      </div>
    </div>
  );
}

export default WithVerifyMailModal(WithVerifyMobileModal(MyNavbar));
